import {
  ar,
  cs,
  de,
  enUS,
  es,
  fr,
  hr,
  it,
  ja,
  ko,
  ms,
  nl,
  pl,
  pt,
  ro,
  sk,
  sl,
  sr,
  tr,
  uk,
  zhCN,
} from 'date-fns/locale';

export const dateFnsLocales = {
  ar: ar,
  cmn: zhCN,
  cs: cs,
  de: de,
  en: enUS,
  es: es,
  fr: fr,
  hr: hr,
  it: it,
  ja: ja,
  ko: ko,
  ms: ms,
  nl: nl,
  pl: pl,
  pt: pt,
  ro: ro,
  sk: sk,
  sl: sl,
  sr: sr,
  tr: tr,
  uk: uk,
};
